import styled from 'styled-components'

export const CartItemWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid ${props => props.theme.color.line};
`

export const CartItemImage = styled.div`
  width: 132px;
  margin-right: 32px;
  height: 132px;
`

export const CartItemContent = styled.div`
  flex-grow: 1;
`

export const CartItemTitle = styled.div`
  font-weight: 500;
  font-size: 22px;
`

export const CartItemCaption = styled.div`
  opacity: 0.5;
`

export const CartItemActions = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 12px;
`

export const CartItemPrice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const CartItemPriceQty = styled.div`
  font-weight: 500;
  font-size: 20px;
  margin-right: 8px;
  opacity: 0.5;
  letter-spacing: 2px;
`

export const CartItemPriceValue = styled.div`
  font-size: 24px;
  font-weight: 600;
`
